import type { FeatureToggleName } from '../feature-toggle';
import { CaptchaConfig } from './shared/captcha-config';

export enum MovinmotionApplication {
  core = 'core',
  accounting = 'accounting',
  nda = 'nda',
  worker = 'worker',
  social = 'social',
  talents = 'talents',
  odalie = 'odalie',
  adminBo = 'adminBo',
}

export interface Environment {
  environment: string;
  production: boolean;
  api: {
    movinmotionBackend: string;
    movinmotionService: string;
  };
  appEndpoints: {
    talents: string;
    core: string;
    filmfrance: string;
    nda: string;
    movinmotion: string;
  };
  authentication: {
    url: string;
    sessionExpiredPath: string;
    queryParamKeys: {
      redirectUrl: string;
      resetPassword: string;
      changePassword: string;
      email: string;
      language: string;
      display: string;
    };
  };

  apps: {
    core: string;
    employeur: string;
    worker: string;
    compta: string;
    talents: string;
    insurance: string;
    socialPlay: string;
    social: string;
    admin: string;
    movinmotion: string;
  };

  movinmotionAppUrls: { [key in MovinmotionApplication]: string };

  thirdParty: {
    siren: {
      endpoint: string;
      token: string;
    };
    googlePlaces: string;
    yousign: {
      sandbox: boolean;
    };
    gtmId?: string;
    mixpanel?: Mixpanel;
    axeptio?: {
      clientId: string;
      cookiesVersion: string;
    };
  };
  bucket: {
    [key in string]: string;
  };
  cookieDomain: string;
  captcha: CaptchaConfig;
  featureToggles?: Partial<Record<FeatureToggleName, boolean>>;
}

interface Mixpanel {
  enabled?: boolean;
  token?: string;
  name?: MixpanelName;
}

type MixpanelName = 'MM preprod' | 'MM prod' | 'MM test';
